import React from 'react';
import {flowRight as compose} from 'lodash';
import {withTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import {Mutation} from 'react-apollo';
import ConfirmModal from './ConfirmModal';
import {Button} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faEnvelope} from '@fortawesome/free-solid-svg-icons';
import Error from './Error/Error';
import gql from 'graphql-tag';

const GRAPHQL_MUTATION_SEND_ACTIVATION_EMAIL = gql`
  mutation sendActivationEmail($userId: ID!) {
    sendActivationEmail(userId: $userId)
  }
`;

const displayError = t => <Error error={t('errorWhileSendingMail')}/>;

const SendActivationMail = ({user, t}) => {
  if (!user.isDeleted && !user.isActive) {
    return (
      <div>
        <Mutation
          mutation={GRAPHQL_MUTATION_SEND_ACTIVATION_EMAIL}
          variables={{userId: user.id}}
        >
          {(mutation) => (
            <ConfirmModal
              title={t('resendConfirmEmail')}
              mutation={mutation}
              displayError={() => displayError(t)}
              size={'m'}
              confirmBtn={'yes'}
              cancelBtn={'no'}
            >
              {askConfirmation => (
                <div className="btn-disable">
                  <Button className="btn-update btn-update-disable" onClick={askConfirmation}>
                    <FontAwesomeIcon icon={faEnvelope} color="#329aef" size="sm"/>
                  </Button>
                </div>
              )}
            </ConfirmModal>
          )}
        </Mutation>
      </div>
    );
  } else {
    return null;
  }
};

SendActivationMail.propTypes = {
  t: PropTypes.func.isRequired,
  user: PropTypes.shape({
    isDeleted: PropTypes.bool.isRequired,
    isActive: PropTypes.bool.isRequired,
  }).isRequired,
};

export default compose(
  withTranslation('user'),
)(SendActivationMail);
